import styled from 'styled-components';


export const TableWrapper = styled.table`
  width: 100%;
  max-width: 100%;

  thead > tr > th {
    border-bottom-width: 1px;
    padding: 12px 8px 5px;
    font-size: 12px;
    text-transform: uppercase;
    color: ${props => props.black ? "#000" : "#fff"};
    font-weight: 700;
    vertical-align: middle;
    border-color: #e3e3e3;
    border-bottom: 1px solid #ddd;
    line-height: 16px;
  }

  thead:first-child>tr:first-child>th {
    border-top: 0;
  }

  tbody>tr {
    position: relative;

    &:hover {
      cursor: pointer;
      background-color: ${props => props.hover ? "#f9f9f9" : "#fff"};
    }
  }
  tbody > tr > td > span{
    @media (min-width: 992px){
      display: none;
      text-align: left;
    }
    @media (max-width: 992px){
      padding-right: 5px;
      font-size: 13px;
      font-weight: normal;
    }
  }
  tbody > tr > td > i {
    text-align: center;
  }

  tbody > tr > td {
    padding: 12px 8px;
    vertical-align: middle;
    border-color: #e3e3e3;
    line-height: 20px;
    border-top: 1px solid #ddd;
    max-width: 450px;
    text-overflow: ellipsis;
    overflow: hidden;
    word-wrap: break-word;

    @media (max-width: 992px){
      text-align: left;
      padding: 5px 8px;
      font-weight: bold;
    }
    
    @media (max-width: 1154px){
      max-width: ${props => props.maxNewsWidth ? "210px" : "450px"};
    }
  }

  @media (max-width: 992px) {
    tbody, tr, tr > th, tr > td {
      width: 100% !important;
      display: block !important;
    }
    &:first-child{
      margin-top: 20px;
      border-top: 1px solid #ddd;
    }

    thead, tfoot {
      display: block;
    }
    thead {
      @media (max-width: 992px){
        display: none;
      }
    }

    tr {
      padding-top: 0;
      padding-bottom: 1em;
      box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
    }

    tr > th, tr > td {
      background: none;
      border: none !important;
      padding: 0.25em 0.75em;
      box-shadow: none !important;
    }
  }
`;

export const TableWrapperGrayHover = styled.table`
width: 100%;
max-width: 100%;

thead > tr > th {
  border-bottom-width: 1px;
  padding: 12px 8px 5px;
  font-size: 12px;
  text-transform: uppercase;
  color: ${props => props.black ? "#000" : "#fff"};
  font-weight: 700;
  vertical-align: middle;
  border-color: #e3e3e3;
  border-bottom: 1px solid #ddd;
  line-height: 16px;
}

thead:first-child>tr:first-child>th {
  border-top: 0;
}

tbody>tr {
  position: relative;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.hover ? "red" : "rgba(255,255,255,0.3)"};
  }
}
tbody > tr > td > span{
  @media (min-width: 992px){
    display: none;
    text-align: left;
  }
  @media (max-width: 992px){
    padding-right: 5px;
    font-size: 13px;
    font-weight: normal;
  }
}
tbody > tr > td > i {
  text-align: center;
}

tbody > tr > td {
  padding: 12px 8px;
  vertical-align: middle;
  border-color: #e3e3e3;
  line-height: 20px;
  border-top: 1px solid #ddd;

  @media (max-width: 992px){
    text-align: left;
    padding: 5px 8px;
    font-weight: bold;
  }
}

@media (max-width: 992px) {
  tbody, tr, tr > th, tr > td {
    width: 100% !important;
    display: block !important;
  }
  &:first-child{
    margin-top: 20px;
    border-top: 1px solid #ddd;
  }

  thead, tfoot {
    display: block;
  }
  thead {
    @media (max-width: 992px){
      display: none;
    }
  }

  tr {
    padding-top: 0;
    padding-bottom: 1em;
    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1) inset !important;
  }

  tr > th, tr > td {
    background: none;
    border: none !important;
    padding: 0.25em 0.75em;
    box-shadow: none !important;
  }
}
`;

export const TdCenter = styled.td`
  text-align: center;

  i {
    font-size: 22px;
    color: #feac01;
  }
`;



// WEBPACK FOOTER //
// ./src/components/table/components.js